export default function getMentionSuggestions<
  Person extends { id: string; name?: string | null },
>(
  participants: readonly Person[],
  recentSenderIds: readonly string[],
  currentUserId: string,
  search: string,
): Person[] {
  if (search) {
    return participants
      .filter((person) =>
        (person.name ?? '')
          .toLocaleLowerCase()
          .includes(search.toLocaleLowerCase()),
      )
      .slice(0, 3);
  }

  const eligiblePeople = new Map(
    participants
      .filter((person) => person.id !== currentUserId)
      .map((person) => [person.id, person]),
  );
  const suggestions: Person[] = [];
  for (const personId of recentSenderIds) {
    const person = eligiblePeople.get(personId);
    if (!person) continue;
    suggestions.push(person);
    eligiblePeople.delete(personId);
    if (suggestions.length === 3) return suggestions;
  }
  for (const person of eligiblePeople.values()) {
    suggestions.push(person);
    if (suggestions.length === 3) break;
  }
  return suggestions;
}
